import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { Apollo, Mutation } from "apollo-angular";


export class UpdateIndicatorCalculationInput {
  indicator?: string;
  reductionType?: string;
  metric?: string;
  conversionFactor?: number;
}

export type UpdateIndicatorCalculationMutationVariables = {
  id: number;
  data: UpdateIndicatorCalculationInput;
};

export type UpdateIndicatorCalculationMutation = {
  updateIndicatorCalculation: {
    id: string;
    indicator: string;
    reductionType: string;
    metric: string;
    conversionFactor: number;
  };
};


export const UpdateIndicatorCalculationDocument = gql`
  mutation UpdateIndicatorCalculation($id: Float!, $data: UpdateIndicatorCalculationDto!) {
    updateIndicatorCalculation(id: $id, data: $data) {
      id
      indicator
      reductionType
      metric
      conversionFactor
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateIndicatorCalculationGQL extends Mutation<
  UpdateIndicatorCalculationMutation,
  UpdateIndicatorCalculationMutationVariables
> {
  document = UpdateIndicatorCalculationDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
